export { Faq } from './Faq.component';
